import type { Seller } from '@prisma/client'
import type { SerializeFrom } from '@remix-run/server-runtime'

import invariant from '~/utils/invariant'

import { useMatchesData } from './use-matches-data'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isSerializedSeller(seller: any): seller is SerializeFrom<Seller> {
  return (
    seller &&
    typeof seller === 'object' &&
    typeof seller.email === 'string' &&
    typeof seller.createdAt === 'string'
  )
}

export function useOptionalSeller(): Seller | undefined {
  const data = useMatchesData('routes/__shop')
  if (!data || !isSerializedSeller(data.seller)) {
    return undefined
  }
  return {
    ...data.seller,
    createdAt: new Date(data.seller.createdAt),
    updatedAt: new Date(data.seller.updatedAt),
  }
}

export function useSeller(): Seller {
  const maybeSeller = useOptionalSeller()
  invariant(
    maybeSeller,
    'No seller found in shop loader, but seller is required by useSeller'
  )
  return maybeSeller
}
